import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'

import { useMediaQuery } from 'src/lib/use-media-query'
import styles from 'src/styles/common.module.scss'

const BREAKPOINT_RULES: Record<string, string[]> = {
    desktop: ['ERHALTEN'],
    small: ['LOSE', 'ERHALTEN'],
}

export const TextHeaderDe = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    let breakAfterWords = BREAKPOINT_RULES.small

    if (isDesktop) {
        breakAfterWords = BREAKPOINT_RULES.desktop
    }

    return (
        <HighlightedText
            text="RUBBELN SIE DIE LOSE UND ERHALTEN SIE IHREN BONUS"
            highlights={[{ word: 'SIE' }, { word: 'IHREN' }, { word: 'BONUS' }]}
            breakAfterWords={breakAfterWords}
            className={styles.text_header}
        />
    )
}
